import {OnIssueVo} from '../../common/shared/api/nicolas/vo/enums/OnIssueVo.enum';
import {TextTKey} from '../../common/type';
import {OnIssue} from '../generated/types';

export function createOnIssue(on_issue?: OnIssueVo): OnIssue {
  if (!on_issue) {
    return OnIssue.Unknown;
  }
  switch (on_issue) {
    case 'Y':
      return OnIssue.Ing;
    case 'N':
      return OnIssue.End;
    case 'P':
      return OnIssue.Pause;
    default:
      return OnIssue.Unknown;
  }
}

export const ON_ISSUE_VO_TITLE_MAP: {[key in OnIssueVo]: TextTKey} = {
  [OnIssueVo.End]: {
    text: '완결',
    textTKey: 'common_content_completed',
  },
  [OnIssueVo.Ing]: {
    text: '연재중',
    textTKey: 'library_content_ongoing',
  },
  [OnIssueVo.Pause]: {
    text: '휴재',
    textTKey: 'common_content_rest',
  },
  [OnIssueVo.PauseLegacy]: {
    text: '휴재',
    textTKey: 'common_content_rest',
  },
};
